import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";

const items = [
  "ACTION PACKED ADVENTURES",
  "HOLIDAY CAMPS",
  "THE DOWNS PREPARATORY SCHOOL",
  "YEARS 1 TO 8",
];

export const MarqueeBanner = () => {
  return (
    <section
      className="bg-sky-400 py-6 md:py-8 overflow-hidden border-y-4 border-slate-900"
      data-testid="marquee-section"
    >
      <Marquee speed={60} gradient={false} autoFill>
        {items.map((text, i) => (
          <span key={i} className="marquee-item">
            <span className="font-display font-black text-4xl md:text-6xl tracking-tight text-slate-900 mx-6">
              {text}
            </span>
            <Star
              className="h-8 w-8 md:h-12 md:w-12 text-white mx-4"
              fill="currentColor"
            />
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default MarqueeBanner;
